/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestSetItem } from './RequestSetItem';
import {
    RequestSetItemFromJSON,
    RequestSetItemFromJSONTyped,
    RequestSetItemToJSON,
    RequestSetItemToJSONTyped,
} from './RequestSetItem';

/**
 * 
 * @export
 * @interface RequestRegistAmazonItemsRequest
 */
export interface RequestRegistAmazonItemsRequest {
    /**
     * 実出荷単位数
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    actualShippingNum?: number;
    /**
     * Amazon商品名
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    amazonItemName: string;
    /**
     * 納品数
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    arriveCount: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    asin: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    baseId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    cellerBaseId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    cellerUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    deliveryUnit: string;
    /**
     * セットがない場合に必須項目
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    expectedCount?: number;
    /**
     * セットなし時の賞味期限
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    expiryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    fnsku: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    imageUrl?: string;
    /**
     * セラー要確認商品の登録かどうかのフラグ
     * @type {boolean}
     * @memberof RequestRegistAmazonItemsRequest
     */
    isNeedConfimationItem: boolean;
    /**
     * JANコード
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    jan?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    memo?: string;
    /**
     * Amazonセット数
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    setCount: number;
    /**
     * セット情報（1セット＝1行）
     * @type {Array<RequestSetItem>}
     * @memberof RequestRegistAmazonItemsRequest
     */
    setItems?: Array<RequestSetItem>;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    sku: string;
    /**
     * 保管場所
     * @type {string}
     * @memberof RequestRegistAmazonItemsRequest
     */
    storageLocation?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    sumNum?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistAmazonItemsRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestRegistAmazonItemsRequest interface.
 */
export function instanceOfRequestRegistAmazonItemsRequest(value: object): value is RequestRegistAmazonItemsRequest {
    if (!('amazonItemName' in value) || value['amazonItemName'] === undefined) return false;
    if (!('arriveCount' in value) || value['arriveCount'] === undefined) return false;
    if (!('asin' in value) || value['asin'] === undefined) return false;
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('deliveryUnit' in value) || value['deliveryUnit'] === undefined) return false;
    if (!('fnsku' in value) || value['fnsku'] === undefined) return false;
    if (!('isNeedConfimationItem' in value) || value['isNeedConfimationItem'] === undefined) return false;
    if (!('setCount' in value) || value['setCount'] === undefined) return false;
    if (!('sku' in value) || value['sku'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestRegistAmazonItemsRequestFromJSON(json: any): RequestRegistAmazonItemsRequest {
    return RequestRegistAmazonItemsRequestFromJSONTyped(json, false);
}

export function RequestRegistAmazonItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestRegistAmazonItemsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'actualShippingNum': json['actual_shipping_num'] == null ? undefined : json['actual_shipping_num'],
        'amazonItemName': json['amazon_item_name'],
        'arriveCount': json['arrive_count'],
        'asin': json['asin'],
        'baseId': json['base_id'],
        'cellerBaseId': json['celler_base_id'] == null ? undefined : json['celler_base_id'],
        'cellerUserId': json['celler_user_id'] == null ? undefined : json['celler_user_id'],
        'deliveryUnit': json['delivery_unit'],
        'expectedCount': json['expected_count'] == null ? undefined : json['expected_count'],
        'expiryDate': json['expiry_date'] == null ? undefined : json['expiry_date'],
        'fnsku': json['fnsku'],
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
        'isNeedConfimationItem': json['is_need_confimation_item'],
        'jan': json['jan'] == null ? undefined : json['jan'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'setCount': json['set_count'],
        'setItems': json['set_items'] == null ? undefined : ((json['set_items'] as Array<any>).map(RequestSetItemFromJSON)),
        'sku': json['sku'],
        'storageLocation': json['storage_location'] == null ? undefined : json['storage_location'],
        'sumNum': json['sum_num'] == null ? undefined : json['sum_num'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestRegistAmazonItemsRequestToJSON(json: any): RequestRegistAmazonItemsRequest {
    return RequestRegistAmazonItemsRequestToJSONTyped(json, false);
}

export function RequestRegistAmazonItemsRequestToJSONTyped(value?: RequestRegistAmazonItemsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actual_shipping_num': value['actualShippingNum'],
        'amazon_item_name': value['amazonItemName'],
        'arrive_count': value['arriveCount'],
        'asin': value['asin'],
        'base_id': value['baseId'],
        'celler_base_id': value['cellerBaseId'],
        'celler_user_id': value['cellerUserId'],
        'delivery_unit': value['deliveryUnit'],
        'expected_count': value['expectedCount'],
        'expiry_date': value['expiryDate'],
        'fnsku': value['fnsku'],
        'image_url': value['imageUrl'],
        'is_need_confimation_item': value['isNeedConfimationItem'],
        'jan': value['jan'],
        'memo': value['memo'],
        'set_count': value['setCount'],
        'set_items': value['setItems'] == null ? undefined : ((value['setItems'] as Array<any>).map(RequestSetItemToJSON)),
        'sku': value['sku'],
        'storage_location': value['storageLocation'],
        'sum_num': value['sumNum'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

